import React from "react";
import { CheckIcon, XIcon } from "../../design-system/icons";
import { typography } from "../../design-system/tokens";

/**
 * Spinning loader icon for the "saving" state.
 * Uses a simple SVG circle animation in amber to match the original color.
 */
const SavingSpinner = ({ className = "w-4 h-4" }) => (
  <svg
    className={`${className} animate-spin text-amber-500`}
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="3"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v3a5 5 0 00-5 5H4z"
    />
  </svg>
);

/**
 * Icon-only save status indicator.
 *   saved    → green check
 *   saving   → amber spinner
 *   error    → red x
 *   conflict → red x
 */
const statusMap = {
  saving: { kind: "saving", label: "Saving…" },
  saved: { kind: "saved", label: "Saved" },
  conflict: { kind: "conflict", label: "Conflict" },
  error: { kind: "error", label: "Error" },
};

export default function SaveIndicator({ status, showLabel = false }) {
  if (!status) return null;
  const { kind, label } = statusMap[status] || statusMap.saved;

  const iconEl =
    kind === "saving" ? (
      <SavingSpinner className={showLabel ? "w-5 h-5" : "w-4 h-4"} />
    ) : kind === "saved" ? (
      <CheckIcon size={showLabel ? "md" : "sm"} className="text-green-400" />
    ) : (
      <XIcon size={showLabel ? "md" : "sm"} className="text-red-400" />
    );

  const labelClass =
    kind === "saved"
      ? "text-green-200"
      : kind === "saving"
        ? "text-amber-200"
        : "text-red-200";
  return (
    <span className="inline-flex items-center gap-1" title={label} aria-label={label}>
      {iconEl}
      {showLabel ? <span className={`${typography.bodySmallDark} ${labelClass}`}>{label}</span> : null}
    </span>
  );
}
